"use client"
/* */
import { createContext } from 'react';

const linkContext = createContext({});
const LinkContextProvider = linkContext.Provider;

export { LinkContextProvider, linkContext };
//# sourceMappingURL=context.mjs.map
